import { Pagination } from "services/search";

import {
  VehicleInsurance,
  VehicleInsuranceEditFormValues,
  VehicleInsuranceRow,
} from "./types";
import {
  transformVehicleInsurance,
  transformVehicleInsuranceOnCreate,
  transformVehicleInsuranceOnUpdate,
  transformVehicleInsuranceRow,
} from "./transformations";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
 CALCULATION VEHICLE INSURANCE SEARCH
-----------------------------------------------------------------------------------------*/

export const getVehicleInsurancesAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<VehicleInsuranceRow>> => {
  let path = `/v1/expenses/insurance?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformVehicleInsuranceRow);
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE INSURANCE - BY ID
-----------------------------------------------------------------------------------------*/
export const getVehicleInsuranceAPI = async (
  id: string
): Promise<VehicleInsurance> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/insurance/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleInsurance(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE INSURANCE - CREATE
-----------------------------------------------------------------------------------------*/
export const createVehicleInsuranceAPI = async (
  formValues: VehicleInsuranceEditFormValues
): Promise<VehicleInsurance> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/insurance/",
      method: "POST",
      body: transformVehicleInsuranceOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Auto osiguranje je uspješno kreirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleInsurance(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE INSURANCE - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateVehicleInsuranceAPI = async (
  id: string,
  formValues: VehicleInsuranceEditFormValues
): Promise<VehicleInsurance> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/insurance/${id}`,
      method: "PUT",
      body: transformVehicleInsuranceOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Auto osiguranje je uspješno ažuriran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleInsurance(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - TIRE - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteVehicleInsuranceAPI = async (
  id: string
): Promise<VehicleInsurance> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/insurance/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Auto osiguranje je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformVehicleInsurance(response.data);
};
